module.exports = __webpack_public_path__ + "assets/img/rechargerecord.ace573e.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/icons/rechargerecord.png
// module id = WNVH
// module chunks = 50